import { TPrivilegeType } from "./types";

export let VIPER_URL = "https://nigeriadev.reliablesoftjm.com/";
export const PREVIEW_URL = "https://obi.reliablesoftjm.com/";
// http://obireact.mentem.in

export const VIPER_CONST = {
  base_url: VIPER_URL + "VIPERWS/",
  alwaysOnUsername: "esite3@viponline",
  alwaysOnSessionid: "00009223581026309436128527",
};

export const LOGIN_CREDENTIALS = {
  username: "esite3@viponline",
  password: "5f4dcc3b5aa765d61d8327deb882cf99",
};

export const VMVERSION = "1.0.0.1";

export const PRIVILIGES_TYPE: TPrivilegeType[] = [
  { value: "THEMEEDITOR", label: "Editor" },
  { value: "THEMEPUBLISHER", label: "Publisher" },
];

export const THEMEEDITOR = "THEMEEDITOR";
export const THEMEPUBLISHER = "THEMEPUBLISHER";

export const PAGE_SIZE = [
  { value: 10, label: "10" },
  { value: 20, label: "20" },
  { value: 30, label: "30" },
  { value: 40, label: "40" },
  { value: 50, label: "50" },
];

export const NEW_FIELD = {
  message: {
    backgroundcolor: "#E8F3EE",
    textcolor: "#000",
  },
  errormessage: {
    backgroundcolor: "#efa3aa",
    textcolor: "#000",
  },
  warningmessage: {
    backgroundcolor: "#fbeaec",
    textcolor: "#dc3545",
  },
  linktext: {
    color: "#981040",
    hovercolor: "#000",
  },
};
